import '../css/index.scss'
import smoothscroll from 'smoothscroll-polyfill'
import $ from 'jquery'

smoothscroll.polyfill()

function sendBeacon(active) {
  const tour = window.location.pathname.endsWith('/start')
  navigator.sendBeacon('/beacon.json', JSON.stringify({active, tour}))
}

$(async () => {
  const $audio = $('.audio')
  const audio = $audio.get(0)

  $(document).on('visibilitychange', () => {
    if(document.visibilityState === 'visible') {
      if($('body').hasClass('started')) sendBeacon(true)
    } else {
      sendBeacon(false)
    }
  })

  $(window).on('beforeunload', () => {
    sendBeacon(false)
  })

  $(window).on('scroll', function() {
    var opacFrom = 1
    var opacTo = 0
    var end = 600
    var opacity = opacFrom + Math.min(window.scrollY / end, 1) * (opacTo - opacFrom)
    $('.disc').css({
      opacity: opacity,
      transition: 'none'
    })
  })

  $('.enter').on('click', event => {
    event.preventDefault()
    $('.transcript').fadeIn()
    sendBeacon(true)
  })

  $('.info-trigger').on('click', function() {
    $('.info').toggleClass('open');
    $('.info-close').delay(650).fadeToggle();
  })

  $('.info-close').on('click', function() {
    $('.info').toggleClass('open');
    $(this).toggle();
  })

  $('.controls a').on('click', function(event) {
    event.preventDefault()
    const action = $(this).attr('data-action')

    if(action === 'begin' || action === 'play') audio.play()
    if(action === 'pause') audio.pause()
    if(action === 'forward') {
      audio.currentTime += 15
      audio.play()
    }
    if(action === 'back') {
      audio.currentTime -= 15
      audio.play()
    }
    if(action === 'restart') {
      audio.currentTime = 0
      audio.play()
    }
  })

  $('.transcript__close').on('click', event => {
    event.preventDefault()
    $('.transcript').fadeOut()
    audio.pause()
  })

  $audio.on('play', event => {
    $('body').addClass('playing').addClass('started').removeClass('paused').removeClass('ended')
  })

  $audio.on('pause', event => {
    $('body').removeClass('playing').addClass('paused').removeClass('ended')
  })

  $audio.on('ended', event => {
    $('body').addClass('ended').removeClass('playing').removeClass('paused')
  })

  const $items = $('.transcript__item')
  const times = $items.map(function() {
    return Number($(this).attr('data-time'))
  }).toArray()

  let activeIndex = null

  let lastPost = 0

  $audio.on('timeupdate', event => {
    const time = audio.currentTime
    let index = null

    const diff = time - lastPost

    if(diff > 2.5) {
      sendBeacon(true)
      lastPost = time
    }

    times.forEach((t, i) => {
      if(t <= time) index = i
    })

    if(index !== activeIndex) {
      const $active = $items.eq(index)

      $items.slice(0, index+1).addClass('active')
      $items.slice(index+1, $items.length).removeClass('active')

      $active.find('.transcript__item__offset').get(0).scrollIntoView({behavior: 'smooth'})

      activeIndex = index
    }
  })
})
